<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg4 hero-overly d-flex align-items-center"
      :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-6 col-md-6">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  final banner -->
  <!--=== produto ==========-->
  <div class="services-area1" v-if="ProdutoSelecionado != ''" style="padding-top: 40px;margin-bottom: 0px !important;">
    <div class="container">
      <!-- produto -->
      <div class="row">
        <!-- imagem do produto -->
        <div class="col-lg-6">
          <div class="">
            <v-carousel show-arrows="hover" hide-delimiters>
              <v-carousel-item v-for="produtoImagens in ProdutoSelecionado.insInstitucionalImagens"
                :key="produtoImagens.itgId" :src="$imgURL + produtoImagens.itgUrlImagem" contain></v-carousel-item>
            </v-carousel>
          </div>
        </div>
        <!-- textos do produto -->
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="wrap-wrapper ml-30">
            <div class="properties-caption mb-30">
              <h2 class="mb-30">{{ ProdutoSelecionado.itiNome }}</h2>
              <h4 class="mt-30" v-html="ProdutoSelecionado.itiResumo1"></h4>

              <div v-if="catalogo != ''">
                 <a v-if="catalogo[0].insInstitucionalArquivos.length > 0" :href="$imgURL + catalogo[0].insInstitucionalArquivos[0].iagUrlArquivo" target="_blank"><h5 class="mt-30">{{catalogo[0].itiNome}}</h5></a>
              </div>
              <p v-html="ProdutoSelecionado.itiResumo2" v-show="false"></p>
              <div v-for="sub in ProdutoSelecionado.insInstitucionalGrids.filter(x => x.igsVisivel)" :key="sub.igsId" v-show="false">
                <p><i class="fas fa-check mr-10"></i>{{ sub.igsNome }}</p>
              </div>
            </div>
            <div class="mb-30">
              <a :href="topoMenu[0].itiLinkBtn1" target="_blank" class="header-btn">
                <i class="fab fa-whatsapp"></i> Quero Contato
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- outros produtos -->
    <section style="background-color: rgb(233, 233, 233);">
        <div class="container">
      <div class="row mt-60">
        <div class="col-lg-12 text-center outros" style="padding-top: 30px;">
          <h3>Outros Produtos - {{ tituloCategorias }}</h3>
          <hr>
        </div>
        <div class="col-lg-4" v-for="(produto, index) in ListaProdutosSegmento" :key="produto.itiId">
          <!-- Single -->
          <div class="properties pb-30">
            <div 
              :class="index % 2 === 0 ? 'linha-branca' : 'linha-cinza'" class="properties-card">
              <div class="properties-img">
                <router-link :to="'/ProdutoDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">
                  <img :src="$imgURL + produto.insInstitucionalImagens[0].itgUrlImagem" :alt="produto.itiNome"
                    style="height: 180px;"></router-link>
              </div>
              <div class="wrap-wrapper">
                <div class="properties-caption">
                  <h3 style="font-size: 18px;font-weight: 700;margin-bottom: 10px;">
                    <router-link :to="'/ProdutoDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">{{
                      produto.itiNome }}</router-link>
                  </h3>
                  <p v-html="produto.itiResumo1"></p>
                </div>
                <!--div class="properties-footer d-flex justify-content-between align-items-center" >
                      <div class="class-day">
                        <div class="btn"><router-link
                            :to="'/ProdutosDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">Ver
                            Mais</router-link></div>
                      </div>
                    </div-->
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
    </section>
  </div>
  <!-- final produtos -->

    <PageCallAction></PageCallAction>

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head'
import axios from 'axios';
import PageCallAction from '../components/PageCallAction.vue';

export default {
  name: 'ProdutoDetalheView',
  components: {
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    ProdutoSelecionado: [],
    topoMenu: [],
    ListaProdutosSegmento: [],
    ListaProdutosTodos: [],
    tituloCategorias: '',
    catalogo:[],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },

  },

  async created() {

    // dados topo 
    await axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
       // console.log('topo menu')
       // console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });


 //aqui busca o catalogo
    await axios.get('/Process/InsInstitucional/institucional/51/catalogo/0/x')
      .then(response => {
        this.catalogo = response.data;
        console.log('catalogo')
        console.log(this.catalogo)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca o topo
    await axios.get('/Process/InsInstitucional/institucional/38/topoprodutos/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('topo Banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca produtos
    await axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.ProdutoSelecionado = response.data;
        this.carregaMetas(this.removerTagsHTML(this.ProdutoSelecionado.itiResumo2), this.ProdutoSelecionado.itiNome);
       // console.log('Produto Selecionado')
      //  console.log(this.ProdutoSelecionado)       
      })
      .catch(error => {
        console.error(error);
      });

       const produtosRes = await axios.get('/Process/InsInstitucional/institucional/39/listaprodutos/0/x');
        this.ListaProdutosTodos = produtosRes.data.filter(x => x.itiVisivel);

        this.ListaProdutosSegmento = this.ListaProdutosTodos.filter(x =>
          x.insInstitucionalSegmentos.some(w => w.insSegmentos.sgiId == this.ProdutoSelecionado.insInstitucionalSegmentos[0]?.insSegmentos.sgiId)
        );
        this.tituloCategorias = this.ListaProdutosSegmento[0].insInstitucionalSegmentos[0].insSegmentos.sgiNomeSegmento;

        //console.log('ListaProdutosSegmento')
       // console.log(this.ListaProdutosSegmento)

       // console.log('tituloCategorias')
       // console.log(this.tituloCategorias)
  },
}
</script>

<style scoped></style>